import React from 'react';
import { Card, CardContent } from '@/Components/ui/card';
import { Inline } from '@/Components/ui/layout';
import { Stack } from '@/Components/ui/layout';
import { Text } from '@/Components/ui/typography';
import { cn } from '@/lib/utils';

function TestimonialCard({ image, quote, author, role }) {
  return (
    <Card className={cn(
      "rounded-2xl bg-[#f8f9fa] shadow-md p-6 pr-6 pl-0 border-none mb-10",
      "transition-all hover:-translate-y-1 hover:shadow-lg"
    )}>
      <CardContent className="p-0">
        <Inline spacing="md" align="start" className="gap-5">
          <img 
            src={image} 
            alt={`${author} profile`} 
            className="w-20 h-20 rounded-full object-cover border-[3px] border-white shadow-sm ml-6"
          />
          <Stack spacing="sm" className="flex-1">
            <blockquote className={cn(
              "text-[#333] font-normal text-lg leading-relaxed tracking-wide m-0 mb-4",
              "relative pl-0 before:content-['\"'] before:text-[48px] before:text-[#007bff]",
              "before:absolute before:-left-6 before:-top-2.5"
            )}>
              {quote}
            </blockquote>
            <footer className="text-left font-semibold text-[#555] text-sm">
              - <span className="text-[#007bff]">{author}</span>, <span className="font-normal text-[#777]">{role}</span>
            </footer>
          </Stack>
        </Inline>
      </CardContent>
    </Card>
  );
}

export default TestimonialCard;
